<template>
  <div class="pb-5">
    <div class="row">
      <div class="col-xl-12">
        <div class="d-flex justify-content-between align-items-end">
          <div><h5>Droits utilisateurs</h5></div> 
          <div><a class="btn btn-primary" @click.stop="dialog = true">Ajouter un droit utilisateur</a></div>
        </div>
        <div class="py-5">
          <v-simple-table class="elevation-0">
            <template v-slot:default>
              <thead>
                <tr><th class="text-left pl-2">Nom des droits utilisateurs</th></tr>
              </thead>
              
              <div v-for="userRight in client.userRights" :key="userRight.id" class="px-2">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{ userRight.name }}</div>
                  <div>
                    <v-btn color="transparent" text @click="removeClientUserRight(userRight)">
                      <div class="fa fa-trash" style="color: #e6007e"></div>
                    </v-btn>
                  </div>
                </div>
                <v-divider class="my-0"></v-divider>
              </div>
            </template>
          </v-simple-table>
        </div>  
      </div>
    </div>
    <!-- DIALOG AJOUT DROIT UTILSATEUR -->
    <v-dialog v-model="dialog" max-width="590">
      <v-card>
        <v-card-title class="headline">
           Veuillez sélectionner un droit utilisateur à ajouter à la liste
        </v-card-title>

        <v-card-text>
          <v-combobox
            v-model="model"
            :items="userRights"
            :loading="isLoading"
            hide-no-data
            hide-selected
            item-text="name"
            item-value="@id"
            label="Liste de droits utilisateurs"
            placeholder="Commencer à taper un nom pour rechercher ... "
            prepend-icon="mdi-database-search"
            return-object
          ></v-combobox>
        </v-card-text>

        <v-divider></v-divider>

        <v-expand-transition>
          <div v-if="model !== null">
            <p>Nom du droit utilisateur : {{ model.name }}</p>
          </div>
        </v-expand-transition>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="orange darken-1" text @click="dialog = false">
            Annuler
          </v-btn>

          <v-btn color="blue darken-1" text @click="addClientUserRight"> Ajouter </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Display User -->
    <!-- <div class="py-5">
      <h5>Utilisateurs</h5>
      <v-simple-table fixed-header dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Nom</th>
              <th class="text-left">Prénom</th>
              <th class="text-left">Email</th>
            </tr>
          </thead>
          <tbody>
            <tr class="py-0" v-for="item in client.users" :key="item.lastname" >
              <td style="font-size:13px">{{ item.lastname }}</td>
              <td style="font-size:13px">{{ item.firstname }}</td>
              <td style="font-size:13px">{{ item.email }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div> -->
  </div>
</template>

<script>
import Api from "@/core/services/api.service";

export default {
  model: {
    prop: "client",
    event: "input",
  },
  props: {
    client: Object,
    user: Object,
  },
  data: () => ({
    dialog: false,
    nameLimit: 150,
    userRights: [],
    isLoading: false,
    model: null,
    search: null,
  }),

  mounted() {
    this.getAllUserRights();
  },

  computed: {
    apiUrl() {
      return process.env.VUE_APP_API;
    },
    items() {
      return this.userRights.map((userRight) => {
        const name =
          userRight.name.length > this.nameLimit
            ? userRight.name.slice(0, this.nameLimit) + "..."
            : userRight.name;

        return Object.assign({}, userRight, { name });
      });
    },
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
  },
  methods: {
    getAllUserRights() {
      Api.get("user_rights").then(userRights => {
        this.userRights = userRights.data["hydra:member"];
      });
    },
    addClientUserRight() {
      this.$emit("addClientUserRight", this.model);
      this.dialog = false;
      this.model = null;
    },
    removeClientUserRight(userRight) {
      if (confirm("Are you sure you want to delete this item?")) {
        this.$emit("removeClientUserRight", userRight);
      }
    },
  },
};
</script>
